import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { ActividadGrupoEspecie, ActividadGrupoEspecieBackend } from './actividad-grupo-especie.model';

@Injectable({
  providedIn: 'root'
})
export class ActividadesGrupoEspecieService {
  url: string;  
  endpoint = 'actividadesGruposEspecie';

  constructor(private http: HttpClient) { }

  getActividadesGrupoEspecie(): Observable<ActividadGrupoEspecie[]> {
    return this.http.get<ActividadGrupoEspecie[]>(`${this.url}/${this.endpoint}/`);
  }

  addActividadGrupoEspecie(actividadGrupoEspecie: ActividadGrupoEspecie[]): Observable<ActividadGrupoEspecieBackend> {
    return this.http.post<ActividadGrupoEspecieBackend>(`${this.url}/${this.endpoint}/`, {
      actividad_grupos_especie: actividadGrupoEspecie
    });
  }

  /*
  changeActividadGrupoEspecie(p: ActividadGrupoEspecie): Observable<ActividadGrupoEspecie> {
    return this.http.patch<ActividadGrupoEspecie>(`${this.url}/${this.endpoint}/${p.id}`, {
      actividadGrupoEspecie: p,
      token: this.token
    });
  }

  deleteActividadGrupoEspecie(p: ActividadGrupoEspecie): Observable<ActividadGrupoEspecie> {
    return this.http.delete<ActividadGrupoEspecie>(`${this.url}/${this.endpoint}/${p.id}`, {
      params: { token: this.token }
    });
  }
  */

}
